import React from 'react';
export function Hero() {
  return <div className="relative h-[500px] bg-cover bg-center" style={{
    backgroundImage: "url('https://images.unsplash.com/photo-1605647540924-852290f6b0d5?w=1600')"
  }} data-id="element-139">
      <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-140" />
      <div className="relative h-full flex flex-col items-center justify-center text-white px-4" data-id="element-141">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-142">
          Bem vindos à<br data-id="element-143" />
          Plataforma do Mar
        </h1>
        <div className="mt-6 w-full max-w-2xl" data-id="element-144">
          <input type="text" placeholder="Pesquisar" className="w-full px-6 py-3 rounded-lg text-gray-900" data-id="element-145" />
        </div>
      </div>
    </div>;
}